import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CustomCheckBoxInput from '../../CustomCheckBoxInput/CustomCheckBoxInput';
import { CheckboxGroupField } from '../types';

const CheckboxGroupFieldForm = ({ field }: { field: CheckboxGroupField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);
  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <CustomCheckBoxInput
            label={field.label}
            options={field.options as any}
            value={renderField.value || []}
            onChange={(val) => {
              renderField.onChange(val);
              field.onAfterChange?.(val, { setValue, getValues });
            }}
          />
        )}
      />
      {currentError && <p className="text-danger" style={{ fontSize: 12 }}>{(currentError as any).message}</p>}
    </div>
  );
};

export default CheckboxGroupFieldForm;
